








import Vue from "vue";
import data from "@/assets/data.json";
import { isMobile } from "mobile-device-detect";
import Hello from "../components/Hello.vue";
import Menu from "../components/Menu.vue";
import InfoBox from "./InfoBox.vue";
export default Vue.extend({
  name: "home",
  data: () => {
    return {
      options: ["mm", "mlg", "ng", "unfit", "wahd-tv", "ftd"],
      credits: {
        mm: "Photo Credit: Maison populaire : « All rights reserved © »",
        mlg: "",
        ng: "Photo Credit: Ingrid Burrington",
        "wahd-tv": "Photo Credit: Margarida Malarkey",
        unfit: "Photo Credit: Tega Brain",
        ftd: ""
      },
      current: "ftd",
      data: data,
      isMobile: isMobile
    };
  },
  mounted: function() {
    this.current = this.options[Math.floor(Math.random() * 6)];
  },
  components: {
    Menu,
    InfoBox
  }
});
